import axios from "axios"
import { REACT_APP_API } from '../../config'

const FILES_ROOT = '/files'

/**
 * Actualiza la propiedad order de los File_association recibidos
 * @param {Array<{id: String}>} fileList Arreglo de associations a actualizar
 */
export const updateFileAssociationsOrder = async (fileList, catalogId, entityName) => {
    const formattedFiles = fileList.map((file, index) => ({ id: file.id, order: index + 1 }));
    const payload = {
        files: formattedFiles,
        associationId: catalogId,
        entityName,
    };

    const response = await axios.put(REACT_APP_API + `${FILES_ROOT}/associations/reorder`, payload);

    return response.data;
}
